function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1"
}, React.createElement("g", {
  id: "noun_Facebook_2060938",
  transform: "translate(-22.000000, 0.000000)"
}, React.createElement("path", {
  d: "M72.089,0.02 L59.624,0 C45.62,0 36.57,9.285 36.57,23.656 L36.57,34.563 L24.037,34.563 C22.954,34.563 22.077,35.441 22.077,36.524 L22.077,52.327 C22.077,53.41 22.955,54.287 24.037,54.287 L36.57,54.287 L36.57,94.163 C36.57,95.246 37.447,96.123 38.53,96.123 L54.882,96.123 C55.965,96.123 56.842,95.245 56.842,94.163 L56.842,54.287 L71.496,54.287 C72.579,54.287 73.456,53.41 73.456,52.327 L73.462,36.524 C73.462,36.004 73.255,35.506 72.888,35.138 C72.521,34.77 72.021,34.563 71.501,34.563 L56.842,34.563 L56.842,25.317 C56.842,20.873 57.901,18.617 63.69,18.617 L72.087,18.614 C73.169,18.614 74.046,17.736 74.046,16.654 L74.046,1.98 C74.046,0.899 73.17,0.022 72.089,0.02 Z",
  id: "Path"
})));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "53px",
    height: "97px",
    viewBox: "0 0 53 97",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.7a5480b0.svg";
export { ForwardRef as ReactComponent };